import { AxiosHeaders, type InternalAxiosRequestConfig } from 'axios'
import { getToken } from './auth'
import { sessionTimer } from './sessionTimer'

export const attachAuthToken = async (
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> => {
  const token = await getToken()
  if (!token) {
    return config
  }
  if (sessionTimer.isActive()) {
    sessionTimer.resetTimer()
  }
  return {
    ...config,
    headers: new AxiosHeaders({
      ...config.headers,
      Authorization: `Bearer ${token}`,
    }),
  }
}
